var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgContactActive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax_bold_call-calling",
    "data-name": "vuesax/bold/call-calling",
    transform: "translate(-172 -188)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "call-calling"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4.37,5.15a.77.77,0,0,1-.77-.77,3.481,3.481,0,0,0-.99-1.81A2.791,2.791,0,0,0,.77,1.54.77.77,0,1,1,.77,0,4.25,4.25,0,0,1,3.74,1.51,4.719,4.719,0,0,1,5.15,4.37.781.781,0,0,1,4.37,5.15Z",
    transform: "translate(185.25 193.6)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M7.97,8.75a.77.77,0,0,1-.77-.77A6.438,6.438,0,0,0,.77,1.55.775.775,0,0,1,.76,0,7.989,7.989,0,0,1,8.74,7.98.777.777,0,0,1,7.97,8.75Z",
    transform: "translate(185.26 190)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M9.05,12.95,7.2,14.8a1,1,0,0,1-1.41.01c-.11-.11-.22-.21-.33-.32a28.414,28.414,0,0,1-2.79-3.27A17.828,17.828,0,0,1,.71,7.81,8.586,8.586,0,0,1,0,4.54,5.173,5.173,0,0,1,.36,2.61,4.6,4.6,0,0,1,1.51.94,2.93,2.93,0,0,1,3.59,0,1.879,1.879,0,0,1,4.4.18a1.63,1.63,0,0,1,.67.56L7.39,4.01a3.422,3.422,0,0,1,.4.7,1.581,1.581,0,0,1,.14.61,1.357,1.357,0,0,1-.21.71,3.4,3.4,0,0,1-.56.71l-.76.79a.535.535,0,0,0-.16.4.908.908,0,0,0,.03.23c.03.08.06.14.08.2a8.3,8.3,0,0,0,.93,1.28c.45.52.93,1.05,1.45,1.58.1.1.21.2.31.3A1,1,0,0,1,9.05,12.95Z",
    transform: "translate(174 190)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-4",
    "data-name": "Vector",
    d: "M12.37,4.29a2.54,2.54,0,0,1-.15.85,2.442,2.442,0,0,1-.1.24,4.126,4.126,0,0,1-.68,1.02A4.508,4.508,0,0,1,9.8,7.58c-.01,0-.02.01-.03.01a5.052,5.052,0,0,1-1.92.37,8.334,8.334,0,0,1-3.26-.73A17.564,17.564,0,0,1,1.15,5.25C.76,4.96.37,4.67,0,4.36L3.27,1.09a5.618,5.618,0,0,0,.74.48c.05.02.11.05.18.08a.69.69,0,0,0,.25.04.55.55,0,0,0,.41-.17L5.61.77A3.068,3.068,0,0,1,6.33.21,1.332,1.332,0,0,1,7.04,0a1.6,1.6,0,0,1,.61.13,3.868,3.868,0,0,1,.7.39l3.31,2.35a1.517,1.517,0,0,1,.55.64A2.052,2.052,0,0,1,12.37,4.29Z",
    transform: "translate(181.6 202.04)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-5",
    "data-name": "Vector",
    d: "M0,0H24V24H0Z",
    transform: "translate(196 212) rotate(180)",
    fill: "none",
    opacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactActive);
export default __webpack_public_path__ + "static/media/contact_active.19b2b33396c0f8440086d1dae06342d7.svg";
export { ForwardRef as ReactComponent };